import { Box, Checkbox, FormControl } from '@primer/react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { ComboboxNguonBietToiType } from '../../../components/combobox-nguonbiettoi-type';
import Button from '../../../components/ui/button';
import Modal from '../../../components/ui/modal';
import ModalActions from '../../../components/ui/modal/ModalActions';
import Text from '../../../components/ui/text';
import TextInput from '../../../components/ui/text-input';
import { useCommonContext } from '../../../contexts/common';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { IDmNguonBietToi } from '../../../models/response/category/IDmNguonBietToi';
import { actions } from '../../../state/actions/actionsWrapper';
import { RootState } from '../../../state/reducers';

const NguonBietToiEditModal = () => {
    const { status, editingData } = useSelector((x: RootState) => x.crmCategoryWrapper.nguonBietToi)
    const dispatch = useDispatch();
    const { dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<IDmNguonBietToi>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    })
    const onSubmit = async (data: any) => {
        dispatch(actions.crmCategoryWrapper.nguonBietToi.SAVE_START({
            ...data,
            id: data?.id ?? 0,
            dm_coso_id: dm_coso_id
        }))
    }

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.crmCategoryWrapper.nguonBietToi.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label><Text text='NguonBietToi.Name' /></FormControl.Label>
                        <TextInput block
                            name="name"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} ${translate("NguonBietToi.Name")}`}
                        />

                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='NguonBietToi.NameEn' /></FormControl.Label>
                        <TextInput block
                            name="name_en"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} ${translate("NguonBietToi.NameEn")}`}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='NguonBietToiType.Name' /></FormControl.Label>
                        <ComboboxNguonBietToiType
                            width={'100%'}
                            value={watch("dm_nguonbiettoi_type_id", editingData?.dm_nguonbiettoi_type_id)}
                            onValueChanged={(value) => setValue("dm_nguonbiettoi_type_id", value)}
                        />

                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='Code' /></FormControl.Label>
                        <TextInput block
                            name="viet_tat"
                            register={register}
                            errors={errors}
                            required
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Show campaign</FormControl.Label>
                        <Checkbox checked={watch("is_show_campaign", editingData?.is_show_campaign)}
                            onChange={(e) => {
                                setValue("is_show_campaign", e.target.checked)
                            }}
                        />
                    </FormControl>
                </Box>

                <ModalActions>
                    <Button text='Base.Label.Close' onClick={() => {
                        dispatch(actions.crmCategoryWrapper.nguonBietToi.CLOSE_EDIT_MODAL(undefined))
                    }} />
                    <Button text='Base.Label.Update' variant='primary' type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>

        </Modal>
    );
};

export default NguonBietToiEditModal;